import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useMemo } from "react";

// Register once
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title
);

export default function MonthlyBookings({
  //labels = [],
  //datasets = [],
  monthlyBooking,
  title = "",
  height = 300,
  showLegend = true,
  horizontal = false,
}) {
    // Sample data (replace with props or API data)
    const labels = ["Jan", "Feb", "Mar", "Apr", "May","Jun", "Jul","Aug","Sep","Oct","Nov","Dec"];

  const datasets = [
    {
      label: title,
      data: monthlyBooking || [0, 0,0, 0, 0,0,0,0,0,0,0,0],
      backgroundColor: "#3b82f6",
    }
  ];
  // Memoized data (performance optimization)
  const data = useMemo(() => {
    return {
      labels,
      datasets,
    };
  }, [labels, datasets]);
 
  // Memoized options
  const options = useMemo(() => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      indexAxis: horizontal ? "y" : "x", // horizontal support

      plugins: {
        legend: {
          display: showLegend,
          position: "top",
          display:false
        },
        title: {
          display: !!title,
          text: title,
        },
        tooltip: {
          enabled: true,
        },
      },

      scales: {
        x: {
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true,
        },
      },
    };
  }, [title, showLegend, horizontal]);
  

  // Empty state handling
  if (!labels.length || !datasets.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <div style={{ height }}>
      <Bar data={data} options={options} />
    </div>
  );
}